import React from 'react';
import Icon from './Icon';

const WaterIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 3C12 3 9 7 9 9A3 3 0 0 0 15 9C15 7 12 3 12 3ZM2 15C5 13 7 13 10 15C13 17 15 17 18 15C19.5 14 20.8 14 22 14.5M5 19.5C7.5 18 9 18 12 19.5C15 21 16.5 21 19 19.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default WaterIcon;
